import type { AgentComponentType } from '@reach/shared-types/agent-components';
import { Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../../components/common/PageHeader';
import { newComponentPath } from '../agent-component-paths';
import { COMPONENT_TYPE_COPY } from '../agents-copy';
import { ComponentListContent } from './ComponentListContent';
import styles from './ComponentListPage.module.css';

interface ComponentListPageProps {
  type: AgentComponentType;
}

export const ComponentListPage = ({ type }: ComponentListPageProps) => {
  const { title, description, newLabel, parts } = COMPONENT_TYPE_COPY[type];
  const newComponentLink = (
    <Link to={newComponentPath(type)} className={styles.newComponent}>
      <Plus aria-hidden="true" />
      {newLabel}
    </Link>
  );

  return (
    <section className={styles.page}>
      <PageHeader title={title} description={description} right={newComponentLink} />
      <ul className={styles.parts}>
        {parts.map(part => (
          <li key={part.title}>
            <h2>{part.title}</h2>
            <p>{part.description}</p>
          </li>
        ))}
      </ul>
      <ComponentListContent type={type} />
    </section>
  );
};
